import { ICalendarStatus, IPerson, IProfileTimeZone } from "#webapp/src/__schema__";
import classNames from "classnames";
import React, { CSSProperties } from "react";
import { createFragmentContainer } from "react-relay";
import { calendarStatusFragments } from "./CalendarStatus.gql";
import { TimeWithTooltip } from "./TimeWithTooltip";
import { STATUS_TO_DESCRIPTION, STATUS_TO_ICON } from "./util/description";

type Props = {
  calendarStatus: ICalendarStatus | null;
  profileTimeZone: IProfileTimeZone | null;
  person: IPerson | null;
  calendarId: string;
  hideInfoTip?: boolean;
  hideTimeZone?: boolean;
  style?: CSSProperties;
  className?: string;
  column?: boolean;
};

function CalendarStatusCmpt({
  calendarStatus,
  person,
  calendarId,
  profileTimeZone,
  hideInfoTip,
  hideTimeZone,
  column,
}: Props) {
  const hasDescription = calendarStatus && calendarStatus.status !== "Other";
  const hasTimeZone = !!profileTimeZone && !hideTimeZone;

  if (!calendarStatus || (!hasDescription && !hasTimeZone)) {
    return null;
  }

  const Icon = STATUS_TO_ICON[calendarStatus.status];
  const description = STATUS_TO_DESCRIPTION[calendarStatus.status];

  return (
    <div
      className={classNames("cw-flex cw-text-muted cw-body-base", {
        "cw-flex-col cw-justify-center cw-items-center": column,
      })}
    >
      <span className="cw-flex cw-items-center cw-gap-1">
        <Icon size={20} />
        <span>{description}</span>
      </span>
      {hasDescription && hasTimeZone && !column && <span className="cw-mx-1">•</span>}
      {!hideTimeZone && profileTimeZone && (
        <TimeWithTooltip
          zone={profileTimeZone.timeZone}
          name={person?.profile?.givenName ?? calendarId}
          showTooltip={!hideInfoTip}
        />
      )}
    </div>
  );
}

export const CalendarStatus = createFragmentContainer<Props>(
  CalendarStatusCmpt,
  calendarStatusFragments,
);
